(function () {
  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD'
    }).format((Number(cents) || 0) / 100);
  }

  function text(node, value) {
    if (node) node.textContent = value;
  }

  function parseJson(section, selector, fallback) {
    var script = section.querySelector(selector);
    if (!script) return fallback;

    try {
      return JSON.parse(script.textContent || '');
    } catch (error) {
      console.warn('DIYPRINT print profile config could not be read. Standard apparel paid fallback will be used.', error);
      return fallback;
    }
  }

  function parseVariants(section) {
    return parseJson(section, '[data-diy-product-variants]', []);
  }

  function normalizeBoolean(value, fallback) {
    if (value === true || value === false) return value;
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === 1 || value === '1') return true;
    if (value === 0 || value === '0') return false;
    return fallback;
  }

  function normalizeOptionKey(value) {
    return String(value || '').trim().toLowerCase();
  }

  function normalizePositionKey(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function normalizeInteger(value, fallback) {
    if (value == null || value === '') return fallback;
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function normalizeUploadRuleByOption(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
    return Object.keys(value).reduce(function (rules, key) {
      var rule = value[key];
      if (!rule || typeof rule !== 'object') return rules;
      rules[normalizeOptionKey(key)] = {
        minFiles: normalizeInteger(rule.minFiles != null ? rule.minFiles : rule.min_files, null),
        maxFiles: normalizeInteger(rule.maxFiles != null ? rule.maxFiles : rule.max_files, null),
        dynamicSlots: normalizeBoolean(rule.dynamicSlots != null ? rule.dynamicSlots : rule.dynamic_slots, null),
        purchaseMode: rule.purchaseMode || rule.purchase_mode || ''
      };
      return rules;
    }, {});
  }

  function normalizeUploadRules(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;

    var byOption = value.byOption || value.by_option || {};
    return {
      mode: value.mode || '',
      minFiles: normalizeInteger(value.minFiles != null ? value.minFiles : value.min_files, null),
      maxFiles: normalizeInteger(value.maxFiles != null ? value.maxFiles : value.max_files, null),
      dynamicSlots: normalizeBoolean(value.dynamicSlots != null ? value.dynamicSlots : value.dynamic_slots, false),
      fileRelation: value.fileRelation || value.file_relation || '',
      purchaseMode: value.purchaseMode || value.purchase_mode || '',
      byOption: normalizeUploadRuleByOption(byOption)
    };
  }

  function parseProfile(section) {
    var profile = normalizeProfile(parseJson(section, '[data-diy-print-profile-config]', {}));
    profile.positions = Array.isArray(profile.positions) ? profile.positions : [];
    profile.addonVariants = Array.isArray(profile.addonVariants) ? profile.addonVariants : [];
    if (!profile.surchargeUnitMode && profile.surchargeMode) profile.surchargeUnitMode = profile.surchargeMode;
    if (!profile.pricingMode) profile.pricingMode = profile.surchargeUnitMode === 'no_surcharge' ? 'free' : 'per_position';
    profile.schemaVersion = normalizeInteger(profile.schemaVersion != null ? profile.schemaVersion : profile.schema_version, null);
    profile.productType = profile.productType || profile.product_type || '';
    profile.blankAllowed = normalizeBoolean(profile.blankAllowed, true);
    profile.printRequired = normalizeBoolean(profile.printRequired, false);
    profile.maxSelectedPositions = Number(profile.maxSelectedPositions) || 2;
    profile.uploadMinFiles = normalizeInteger(profile.uploadMinFiles, null);
    profile.uploadMaxFiles = normalizeInteger(profile.uploadMaxFiles, null);
    profile.purchaseMode = profile.purchaseMode || profile.purchase_mode || '';
    profile.productionType = profile.productionType || profile.production_type || '';
    profile.uploadRules = profile.schemaVersion === 2
      ? normalizeUploadRules(profile.uploadRules || profile.upload_rules)
      : null;
    profile.pricingRule = profile.schemaVersion === 2 && profile.pricingRule && typeof profile.pricingRule === 'object'
      ? profile.pricingRule
      : profile.schemaVersion === 2 && profile.pricing_rule && typeof profile.pricing_rule === 'object'
        ? profile.pricing_rule
        : null;
    profile.uploadRuleByOption = normalizeUploadRuleByOption(profile.uploadRuleByOption);
    profile.positions = profile.positions.map(function (position) {
      position.uploadRequired = normalizeBoolean(position.uploadRequired, true);
      position.isDefault = normalizeBoolean(position.isDefault, false);
      position.isRequired = normalizeBoolean(position.isRequired, false);
      position.enabled = normalizeBoolean(position.enabled, true);
      return position;
    });
    return profile;
  }

  function normalizeProfile(profile) {
    var fallback = profile && typeof profile === 'object' ? profile.fallbackProfile : null;
    if (fallback && typeof fallback === 'object') {
      fallback.addonVariants = Array.isArray(fallback.addonVariants) ? fallback.addonVariants : profile.addonVariants;
    }

    if (isValidProfile(profile)) return profile;
    if (isValidProfile(fallback)) {
      fallback.configSource = 'theme_fallback';
      console.warn('DIYPRINT print profile config is incomplete or invalid. Default custom print fallback is active.');
      return fallback;
    }

    console.warn('DIYPRINT print profile fallback is missing. Print surcharge has been disabled to avoid incorrect cart charges.');
    return {
      profileHandle: 'invalid_print_profile_safe_mode',
      customerLabel: 'Print profile needs review',
      helperText: 'This product print profile needs review before printed options are used.',
      configSource: 'safe_no_surcharge_fallback',
      blankAllowed: true,
      printRequired: false,
      maxSelectedPositions: 0,
      pricingMode: 'free',
      surchargeUnitMode: 'no_surcharge',
      surchargeMode: 'no_surcharge',
      addonVariants: [],
      positions: []
    };
  }

  function isValidProfile(profile) {
    if (!profile || typeof profile !== 'object') return false;
    if (!Array.isArray(profile.positions) || !profile.positions.length) return false;

    var mode = profile.surchargeUnitMode || profile.surchargeMode || 'addon_variant';
    if (mode !== 'addon_variant' && mode !== 'no_surcharge') return false;
    if (mode === 'addon_variant' && (!Array.isArray(profile.addonVariants) || !profile.addonVariants.length)) return false;

    return profile.positions.every(function (position) {
      if (!position || typeof position !== 'object') return false;
      if (!position.label) return false;
      if (position.surchargeCents != null && !Number.isFinite(Number(position.surchargeCents))) return false;
      if (position.maxPerGroup != null && !Number.isFinite(Number(position.maxPerGroup))) return false;
      return true;
    });
  }

  function selectedOptions(section) {
    var result = {};

    section.querySelectorAll('.diy-main-product__option').forEach(function (option) {
      var label = option.querySelector('label');
      var select = option.querySelector('.diy-main-product__select');
      if (!label || !select) return;

      var key = label.textContent.trim().toLowerCase();
      var normalizedKey = normalizeOptionKey(key);
      var buttons = option.querySelector('.diy-option-buttons');
      var selectedButton = option.querySelector('[data-option-button].is-selected, [data-option-button][aria-pressed="true"]');
      var value = selectedButton ? selectedButton.getAttribute('data-option-value') || selectedButton.textContent.trim() : select.value;
      var isOrderOption = normalizedKey.indexOf('order option') !== -1 || normalizedKey.indexOf('purchase option') !== -1 || normalizedKey === 'order';
      result.byName = result.byName || {};
      result.byName[normalizedKey] = value;
      var isColour = key === 'colour' || key === 'color' || key === '颜色' || key === '顏色';
      var isSize = key === 'size' || key === '尺寸';

      if (buttons) {
        isColour = isColour || buttons.classList.contains('diy-option-buttons--colour');
        isSize = isSize || (buttons.classList.contains('diy-option-buttons--size') && !isOrderOption);
      }

      if (isColour) {
        result.hasColour = true;
        result.colour = value;
      }
      if (isOrderOption) {
        result.hasOrderOption = true;
        result.orderOption = value;
        result.hasSize = true;
        result.size = value;
      } else if (isSize) {
        result.hasSize = true;
        result.size = value;
      }
    });

    return result;
  }

  function selectedPlacements(section) {
    return Array.prototype.slice.call(section.querySelectorAll('[data-placement-checkbox]'))
      .filter(function (input) {
        return input.checked && !input.closest('[data-diy-bulk-builder]');
      })
      .map(function (input) {
        return input.value;
      });
  }

  function activeUploadInputs(section, profile) {
    return Array.prototype.slice.call(section.querySelectorAll('[data-placement-artwork-file]')).filter(function (input) {
      var position = positionForLabel(profile, input.dataset.placementName || '');
      return !input.disabled && (!position || position.uploadRequired !== false);
    });
  }

  function clearFileInput(input) {
    if (!input) return;
    input.value = '';
    syncUploadControl(input);
  }

  function fileInputHasFile(input) {
    return Boolean(input && input.files && input.files.length > 0);
  }

  function uploadSlotLabel(label, index, totalSlots, required) {
    var suffix = totalSlots > 1 ? ' ' + index : '';
    return 'Upload artwork' + suffix + ' for ' + label + (required ? '' : ' (optional)');
  }

  function artworkPropertyName(label, index, useNumbered) {
    return 'properties[Artwork - ' + label + (useNumbered ? ' ' + index : '') + ']';
  }

  function ensureUploadControl(input) {
    if (!input || input.dataset.diyUploadControlReady === 'true') return;
    input.dataset.diyUploadControlReady = 'true';
    input.classList.add('diy-field__file--native-hidden');

    var control = document.createElement('div');
    control.className = 'diy-upload-control';
    control.setAttribute('data-upload-control', '');

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'diy-upload-control__button';
    trigger.setAttribute('data-upload-trigger', '');
    trigger.textContent = 'Upload artwork';

    var filename = document.createElement('span');
    filename.className = 'diy-upload-control__filename';
    filename.setAttribute('data-upload-filename', '');
    filename.textContent = 'No file uploaded';

    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'diy-upload-control__remove';
    remove.setAttribute('data-upload-remove', '');
    remove.textContent = 'Remove file';
    remove.hidden = true;

    control.appendChild(trigger);
    control.appendChild(filename);
    control.appendChild(remove);
    input.insertAdjacentElement('afterend', control);
    syncUploadControl(input);
  }

  function syncUploadControl(input) {
    if (!input) return;
    var control = input.parentElement ? input.parentElement.querySelector('[data-upload-control]') : null;
    if (!control) return;
    var hasFile = fileInputHasFile(input);
    var trigger = control.querySelector('[data-upload-trigger]');
    var filename = control.querySelector('[data-upload-filename]');
    var remove = control.querySelector('[data-upload-remove]');
    if (trigger) trigger.textContent = hasFile ? 'Change file' : 'Upload artwork';
    if (filename) filename.textContent = hasFile ? input.files[0].name : 'No file uploaded';
    if (remove) remove.hidden = !hasFile || input.disabled;
    control.classList.toggle('is-uploaded', hasFile);
    control.classList.toggle('is-disabled', input.disabled);
  }

  function ensureUploadAreaReady(area) {
    if (!area || area.dataset.diyDynamicUploadReady === 'true') return;
    var input = area.querySelector('[data-placement-artwork-file]');
    if (!input) return;
    var label = area.querySelector('label');
    var slot = document.createElement('div');
    slot.className = 'diy-upload-slot';
    slot.setAttribute('data-upload-slot', '');
    slot.dataset.uploadSlotIndex = '1';

    area.dataset.diyDynamicUploadReady = 'true';
    area.dataset.baseUploadId = input.id || '';
    area.dataset.baseUploadAccept = input.getAttribute('accept') || '';
    area.dataset.baseUploadRequired = input.dataset.uploadRequired || 'true';

    var existingControl = input.nextElementSibling && input.nextElementSibling.matches('[data-upload-control]')
      ? input.nextElementSibling
      : null;

    if (label) slot.appendChild(label);
    slot.appendChild(input);
    if (existingControl) slot.appendChild(existingControl);
    area.insertBefore(slot, area.firstChild);
    input.dataset.uploadSlotIndex = '1';
    ensureUploadControl(input);
  }

  function createUploadSlot(area, label, index) {
    var baseInput = area.querySelector('[data-upload-slot-index="1"] [data-placement-artwork-file]');
    if (!baseInput) return null;
    var slot = document.createElement('div');
    slot.className = 'diy-upload-slot';
    slot.setAttribute('data-upload-slot', '');
    slot.dataset.uploadSlotIndex = String(index);

    var slotLabel = document.createElement('label');
    var id = (area.dataset.baseUploadId || 'ArtworkFile') + '-' + index;
    slotLabel.setAttribute('for', id);

    var input = baseInput.cloneNode(false);
    input.id = id;
    input.value = '';
    delete input.dataset.diyUploadControlReady;
    input.dataset.uploadSlotIndex = String(index);
    input.dataset.placementName = label;
    input.removeAttribute('required');
    input.disabled = true;

    slot.appendChild(slotLabel);
    slot.appendChild(input);
    var addButton = area.querySelector('[data-add-upload-slot]');
    if (addButton) {
      area.insertBefore(slot, addButton);
    } else {
      area.appendChild(slot);
    }
    ensureUploadControl(input);
    return slot;
  }

  function syncUploadSlotsForArea(area, label, requirement, isSelected, uploadRequired) {
    ensureUploadAreaReady(area);

    var configured = requirement.hasConfiguredRule;
    var minFiles = configured ? Math.max(0, Number(requirement.minFiles) || 0) : uploadRequired ? 1 : 0;
    var maxFiles = configured ? Number(requirement.maxFiles) || Math.max(minFiles, 1) : 1;
    maxFiles = Math.max(maxFiles, minFiles, 1);
    var isExpandable = configured && (requirement.dynamicSlots === true || requirement.purchaseMode === 'artwork_only');
    var currentSlots = Array.prototype.slice.call(area.querySelectorAll('[data-upload-slot]'));
    var targetCount = configured ? maxFiles : 1;

    if (isExpandable) {
      var existingCount = currentSlots.length || 1;
      targetCount = Math.min(Math.max(existingCount, minFiles || 1), maxFiles);
    }

    for (var index = currentSlots.length + 1; index <= targetCount; index += 1) {
      createUploadSlot(area, label, index);
    }

    currentSlots = Array.prototype.slice.call(area.querySelectorAll('[data-upload-slot]'));
    currentSlots.forEach(function (slot, slotIndex) {
      var index = slotIndex + 1;
      if (index > targetCount) {
        var removedInput = slot.querySelector('[data-placement-artwork-file]');
        clearFileInput(removedInput);
        slot.remove();
      }
    });

    currentSlots = Array.prototype.slice.call(area.querySelectorAll('[data-upload-slot]'));
    currentSlots.forEach(function (slot, slotIndex) {
      var index = slotIndex + 1;
      var required = isSelected && uploadRequired && (configured ? index <= Math.max(minFiles, 1) : true);
      var input = slot.querySelector('[data-placement-artwork-file]');
      var slotLabel = slot.querySelector('label');
      if (!input) return;
      input.disabled = !isSelected;
      input.required = required;
      input.dataset.placementName = label;
      input.dataset.uploadRequired = required ? 'true' : 'false';
      input.name = artworkPropertyName(label, index, configured && maxFiles > 1);
      if (slotLabel) slotLabel.textContent = uploadSlotLabel(label, index, targetCount, required);
      if (!isSelected) clearFileInput(input);
      syncUploadControl(input);
    });

    var addButton = area.querySelector('[data-add-upload-slot]');
    if (!addButton) {
      addButton = document.createElement('button');
      addButton.type = 'button';
      addButton.className = 'diy-upload-slot__add';
      addButton.setAttribute('data-add-upload-slot', '');
      addButton.textContent = 'Add another artwork';
      area.appendChild(addButton);
    }
    addButton.hidden = !(isSelected && isExpandable && currentSlots.length < maxFiles);
    addButton.disabled = addButton.hidden;
    area.dataset.uploadMaxFiles = String(maxFiles);
  }

  function currentVariant(section, variants) {
    var idInput = section.querySelector('input[name="id"]');
    var id = idInput ? String(idInput.value) : '';
    return variants.find(function (variant) {
      return String(variant.id) === id;
    }) || variants[0] || null;
  }

  function positionForLabel(profile, label) {
    return profile.positions.find(function (position) {
      return position && position.label === label && position.enabled !== false;
    }) || null;
  }

  function profileHasPosition(profile, label) {
    if (!profile.positions.length) return true;
    return Boolean(positionForLabel(profile, label));
  }

  function applyProfileToPlacementControls(section, profile) {
    var hasConfiguredPositions = profile.positions.length > 0;
    section.querySelectorAll('.diy-placement-card').forEach(function (card) {
      var label = card.dataset.placementLabel || '';
      var input = card.querySelector('[data-placement-checkbox]');
      var allowed = !hasConfiguredPositions || profileHasPosition(profile, label);
      card.hidden = !allowed;
      card.classList.toggle('is-profile-disabled', !allowed);
      if (input) {
        input.disabled = !allowed;
        if (!allowed) input.checked = false;
      }
    });
    section.querySelectorAll('[data-placement-modal-choice]').forEach(function (choice) {
      var label = choice.dataset.placementModalChoice || '';
      choice.hidden = hasConfiguredPositions && !profileHasPosition(profile, label);
    });
  }

  function enforceProfileSelection(section, profile) {
    var selected = [];
    var groups = {};
    section.querySelectorAll('[data-placement-checkbox]').forEach(function (input) {
      if (input.closest('[data-diy-bulk-builder]')) return;
      if (!input.checked) return;
      var position = positionForLabel(profile, input.value);
      if (!position) {
        input.checked = false;
        return;
      }
      var group = position.group || position.label || input.value;
      var maxPerGroup = Number(position.maxPerGroup) || 999;
      groups[group] = groups[group] || 0;
      if (selected.length >= profile.maxSelectedPositions || groups[group] >= maxPerGroup) {
        input.checked = false;
        return;
      }
      groups[group] += 1;
      selected.push(input.value);
    });
  }

  function calculateSurcharge(profile, placements) {
    if (profile.schemaVersion === 2 && profile.pricingRule) {
      return calculateV2Surcharge(profile, placements);
    }

    if (profile.pricingMode === 'free' || profile.surchargeUnitMode === 'no_surcharge') return 0;

    return placements.reduce(function (sum, label) {
      var position = positionForLabel(profile, label);
      return sum + (position ? Number(position.surchargeCents) || 0 : 0);
    }, 0);
  }

  function calculateV2Surcharge(profile, placements) {
    var rule = profile.pricingRule || {};
    var mode = String(rule.mode || rule.pricing_mode || '').trim().toLowerCase();

    if (!placements.length || mode === 'no_surcharge') return 0;
    if (mode === 'combination') {
      var combinationPrice = matchingCombinationSurcharge(profile, rule, placements);
      if (combinationPrice != null) return combinationPrice;
      return calculateV2PerPositionSurcharge(profile, rule, placements);
    }
    if (mode === 'per_position') {
      return calculateV2PerPositionSurcharge(profile, rule, placements);
    }

    return calculateV1StyleSurcharge(profile, placements);
  }

  function calculateV1StyleSurcharge(profile, placements) {
    if (profile.pricingMode === 'free' || profile.surchargeUnitMode === 'no_surcharge') return 0;
    return placements.reduce(function (sum, label) {
      var position = positionForLabel(profile, label);
      return sum + (position ? Number(position.surchargeCents) || 0 : 0);
    }, 0);
  }

  function calculateV2PerPositionSurcharge(profile, rule, placements) {
    return placements.reduce(function (sum, label) {
      return sum + v2PositionSurcharge(profile, rule, label);
    }, 0);
  }

  function v2PositionSurcharge(profile, rule, label) {
    var explicit = v2ExplicitPositionSurcharge(profile, rule, label);
    if (explicit != null) return explicit;

    var defaultCents = normalizeInteger(
      rule.defaultSurchargeCents != null ? rule.defaultSurchargeCents : rule.default_surcharge_cents,
      null
    );
    if (defaultCents != null) return defaultCents;

    var surchargeCents = normalizeInteger(rule.surchargeCents != null ? rule.surchargeCents : rule.surcharge_cents, null);
    if (surchargeCents != null) return surchargeCents;

    var position = positionForLabel(profile, label);
    return position ? normalizeInteger(position.surchargeCents, 0) : 0;
  }

  function v2ExplicitPositionSurcharge(profile, rule, label) {
    var priceMap = rule.positionSurcharges || rule.position_surcharges || rule.positions || rule.perPosition || rule.per_position;
    if (!priceMap || typeof priceMap !== 'object' || Array.isArray(priceMap)) return null;

    var tokens = positionTokens(profile, label);
    for (var index = 0; index < tokens.length; index += 1) {
      var value = priceMap[tokens[index]];
      if (value && typeof value === 'object') {
        value = value.surchargeCents != null ? value.surchargeCents : value.surcharge_cents;
      }
      var cents = normalizeInteger(value, null);
      if (cents != null) return cents;
    }

    return null;
  }

  function matchingCombinationSurcharge(profile, rule, placements) {
    var combinations = Array.isArray(rule.combinations) ? rule.combinations : [];
    var selectedSets = placements.map(function (label) {
      return positionTokens(profile, label);
    });

    for (var index = 0; index < combinations.length; index += 1) {
      var combination = combinations[index];
      if (!combination || !Array.isArray(combination.positions)) continue;
      var combinationTokens = combination.positions.map(normalizePositionKey).filter(Boolean);
      if (!combinationTokens.length || combinationTokens.length !== placements.length) continue;

      var matched = combinationTokens.every(function (token) {
        return selectedSets.some(function (tokens) {
          return tokens.indexOf(token) !== -1;
        });
      });
      if (!matched) continue;

      return normalizeInteger(
        combination.surchargeCents != null ? combination.surchargeCents : combination.surcharge_cents,
        0
      );
    }

    return null;
  }

  function positionTokens(profile, label) {
    var position = positionForLabel(profile, label);
    var tokens = [label];
    if (position) {
      tokens.push(position.key);
      tokens.push(position.label);
      tokens.push(position.group);
    }

    return tokens.map(normalizePositionKey).filter(function (token, index, allTokens) {
      return token && allTokens.indexOf(token) === index;
    });
  }

  function priceLabelFor(profile, label) {
    var position = positionForLabel(profile, label);
    if (!position) return '';
    if (position.priceLabel) return position.priceLabel;
    return position.surchargeCents ? '+' + money(position.surchargeCents) : '+$0';
  }

  function syncProfileUploadSlots(section, profile) {
    var selected = selectedPlacements(section);
    var selectedMap = {};
    var requirement = currentUploadRequirement(profile, selectedOptions(section), []);
    selected.forEach(function (label) {
      selectedMap[label] = true;
    });

    section.querySelectorAll('[data-placement-upload-area]').forEach(function (area) {
      ensureUploadAreaReady(area);
      var input = area.querySelector('[data-placement-artwork-file]');
      if (!input) return;

      var label = input.dataset.placementName || area.dataset.placementUploadLabel || area.dataset.placementUploadArea || '';
      var position = positionForLabel(profile, label);
      var isSelected = Boolean(selectedMap[label]);
      var isKnownPosition = !profile.positions.length || Boolean(position);
      var uploadRequired = !position || position.uploadRequired !== false;

      if (!isKnownPosition) {
        isSelected = false;
      }

      area.hidden = !isSelected;
      area.classList.toggle('is-disabled', !isSelected);
      syncUploadSlotsForArea(area, label, requirement, isSelected, uploadRequired);
    });

    var emptyMessage = section.querySelector('[data-placement-upload-empty]');
    if (emptyMessage) emptyMessage.hidden = selected.length > 0;
  }

  function buildAddonItems(profile, surchargeCents, mainQuantity, linkId, placementText) {
    if (profile.surchargeUnitMode !== 'addon_variant' || surchargeCents <= 0) return [];

    var remaining = surchargeCents;
    var units = profile.addonVariants
      .filter(function (variant) {
        return variant && Number(variant.variantId) && Number(variant.cents) > 0;
      })
      .sort(function (a, b) {
        return Number(b.cents) - Number(a.cents);
      });

    var items = [];
    units.forEach(function (unit) {
      var cents = Number(unit.cents);
      var quantity = Math.floor(remaining / cents);
      if (!quantity) return;
      remaining -= quantity * cents;
      items.push({
        id: Number(unit.variantId),
        quantity: quantity * mainQuantity,
        properties: {
          _diyprint_addon: 'print_surcharge',
          _linked_product_id: linkId,
          _surcharge_units_per_item: String(quantity),
          _print_profile: profile.profileHandle || '',
          _surcharge_for_positions: placementText,
          _surcharge_unit_label: unit.label || money(cents)
        }
      });
    });

    if (remaining !== 0) {
      throw new Error('No surcharge unit combination for ' + money(surchargeCents));
    }

    return items;
  }

  function uploadedFileCount(inputs) {
    return inputs.reduce(function (sum, input) {
      return sum + (input.files ? input.files.length : 0);
    }, 0);
  }

  function currentUploadRequirement(profile, options, uploadInputs) {
    if (profile.schemaVersion === 2 && profile.uploadRules) {
      return currentV2UploadRequirement(profile, options, uploadInputs);
    }

    var rule = null;
    var optionCandidates = [];
    if (options.orderOption) optionCandidates.push(options.orderOption);
    if (options.size) optionCandidates.push(options.size);
    if (options.byName) {
      Object.keys(options.byName).forEach(function (key) {
        optionCandidates.push(options.byName[key]);
      });
    }

    optionCandidates.some(function (value) {
      var found = profile.uploadRuleByOption[normalizeOptionKey(value)];
      if (found) {
        rule = found;
        return true;
      }
      return false;
    });

    var minFiles = rule && rule.minFiles != null ? rule.minFiles : profile.uploadMinFiles;
    var maxFiles = rule && rule.maxFiles != null ? rule.maxFiles : profile.uploadMaxFiles;

    return {
      hasConfiguredRule: Boolean(rule) || minFiles != null || maxFiles != null,
      minFiles: minFiles,
      maxFiles: maxFiles,
      dynamicSlots: false,
      purchaseMode: rule && rule.purchaseMode ? rule.purchaseMode : profile.purchaseMode || '',
      legacyRequiredInputs: uploadInputs.filter(function (input) {
        return !input.files || input.files.length === 0;
      })
    };
  }

  function currentV2UploadRequirement(profile, options, uploadInputs) {
    var uploadRules = profile.uploadRules || {};
    var rule = null;
    var optionCandidates = [];
    if (options.orderOption) optionCandidates.push(options.orderOption);
    if (options.size) optionCandidates.push(options.size);
    if (options.byName) {
      Object.keys(options.byName).forEach(function (key) {
        optionCandidates.push(options.byName[key]);
      });
    }

    optionCandidates.some(function (value) {
      var found = uploadRules.byOption && uploadRules.byOption[normalizeOptionKey(value)];
      if (found) {
        rule = found;
        return true;
      }
      return false;
    });

    var minFiles = rule && rule.minFiles != null ? rule.minFiles : uploadRules.minFiles;
    var maxFiles = rule && rule.maxFiles != null ? rule.maxFiles : uploadRules.maxFiles;
    var dynamicSlots = rule && rule.dynamicSlots != null ? rule.dynamicSlots : uploadRules.dynamicSlots;

    return {
      hasConfiguredRule: true,
      minFiles: minFiles,
      maxFiles: maxFiles,
      dynamicSlots: dynamicSlots === true,
      purchaseMode: rule && rule.purchaseMode ? rule.purchaseMode : uploadRules.purchaseMode || profile.purchaseMode || '',
      legacyRequiredInputs: uploadInputs.filter(function (input) {
        return !input.files || input.files.length === 0;
      })
    };
  }

  function state(section, variants, profile) {
    var variant = currentVariant(section, variants);
    var options = selectedOptions(section);
    var placements = selectedPlacements(section);
    var uploadInputs = activeUploadInputs(section, profile);
    var uploadRequirement = currentUploadRequirement(profile, options, uploadInputs);
    var fileCount = uploadedFileCount(uploadInputs);
    var missingUploads = uploadRequirement.legacyRequiredInputs;
    if (uploadRequirement.hasConfiguredRule && uploadRequirement.minFiles != null) {
      missingUploads = fileCount < uploadRequirement.minFiles ? uploadInputs.filter(function (input) {
        return !input.files || input.files.length === 0;
      }).slice(0, 1) : [];
    }
    var tooManyUploads = uploadRequirement.maxFiles != null && fileCount > uploadRequirement.maxFiles;
    var basePrice = variant ? Number(variant.price) || 0 : 0;
    var surcharge = calculateSurcharge(profile, placements);
    var placementText = placements.length ? placements.join(', ') : 'No print selected';
    var requiresPrintSelection = profile.printRequired === true || profile.blankAllowed === false;

    return {
      variant: variant,
      options: options,
      placements: placements,
      missingUploads: missingUploads,
      fileCount: fileCount,
      uploadRequirement: uploadRequirement,
      tooManyUploads: tooManyUploads,
      basePrice: basePrice,
      surcharge: surcharge,
      cartPrice: basePrice + surcharge,
      placementText: placementText,
      requiresPrintSelection: requiresPrintSelection,
      missingPrintSelection: requiresPrintSelection && placements.length === 0
    };
  }

  function updateConfigurator(section, variants, profile) {
    var form = section.querySelector('form[action*="/cart/add"]') || section.querySelector('form');
    if (!form) return;

    applyProfileToPlacementControls(section, profile);
    enforceProfileSelection(section, profile);
    syncProfileUploadSlots(section, profile);
    var current = state(section, variants, profile);
    var uploadText = 'No artwork needed for blank item';
    if (current.missingPrintSelection) {
      uploadText = 'Choose a print position to continue';
    }
    if (current.placements.length && current.missingUploads.length) {
      uploadText = current.uploadRequirement.minFiles
        ? 'At least ' + current.uploadRequirement.minFiles + ' artwork file' + (current.uploadRequirement.minFiles > 1 ? 's' : '') + ' required'
        : current.missingUploads.length + ' artwork upload' + (current.missingUploads.length > 1 ? 's' : '') + ' required';
    } else if (current.placements.length && current.tooManyUploads) {
      uploadText = 'Maximum ' + current.uploadRequirement.maxFiles + ' artwork files';
    } else if (current.placements.length) {
      uploadText = 'Artwork ready';
    }

    var surchargeText = current.surcharge ? money(current.surcharge) : '$0.00';
    var cartPriceText = money(current.cartPrice);

    text(section.querySelector('[data-summary-base]'), money(current.basePrice));
    text(section.querySelector('[data-summary-surcharge]'), surchargeText);
    text(section.querySelector('[data-summary-total]'), cartPriceText);
    text(section.querySelector('[data-summary-colour]'), current.options.hasColour ? current.options.colour || 'N/A' : 'N/A');
    text(section.querySelector('[data-summary-size]'), current.options.hasSize ? current.options.size || 'N/A' : 'N/A');
    text(section.querySelector('[data-summary-positions]'), current.placementText);
    text(section.querySelector('[data-summary-upload-status]'), uploadText);
    text(section.querySelector('[data-sticky-total]'), cartPriceText);
    text(
      section.querySelector('[data-sticky-status]'),
      current.placements.length ? 'Print add-on: ' + surchargeText : current.missingPrintSelection ? 'Print position required' : 'Blank item ready'
    );
    text(
      section.querySelector('[data-summary-rule-note]'),
      profile.surchargeUnitMode === 'addon_variant'
        ? 'Print surcharge is added as linked surcharge units in cart.'
        : 'Promotional print profile: selected print positions add $0 today.'
    );

    var placementProperty = form.querySelector('[data-placement-property]');
    var selectedPositionsProperty = form.querySelector('[data-selected-print-positions-property]');
    var surchargeProperty = form.querySelector('[data-print-surcharge-property]');
    var printRuleProperty = form.querySelector('[data-print-rule-property]');
    var priceStructureProperty = form.querySelector('[data-price-structure-property]');
    var colourProperty = form.querySelector('[data-selected-colour-property]');
    var sizeProperty = form.querySelector('[data-selected-size-property]');
    var orderOptionProperty = form.querySelector('[data-selected-order-option-property]');

    if (placementProperty) placementProperty.value = current.placementText;
    if (selectedPositionsProperty) selectedPositionsProperty.value = current.placementText;
    if (surchargeProperty) surchargeProperty.value = money(current.surcharge);
    if (printRuleProperty) printRuleProperty.value = profile.profileHandle || '';
    if (colourProperty) colourProperty.value = current.options.hasColour ? current.options.colour || '' : '';
    if (sizeProperty) sizeProperty.value = current.options.hasSize ? current.options.size || '' : '';
    if (orderOptionProperty) orderOptionProperty.value = current.options.orderOption || '';
    if (priceStructureProperty) {
      priceStructureProperty.value =
        'Base product: ' + money(current.basePrice) +
        ' | Print surcharge: ' + money(current.surcharge) +
        ' | Cart price with linked surcharge: ' + cartPriceText +
        ' | Print profile: ' + (profile.profileHandle || '') +
        (current.options.orderOption ? ' | Order option: ' + current.options.orderOption : '');
    }

    section.querySelectorAll('.diy-placement-card').forEach(function (card) {
      var label = card.dataset.placementLabel || '';
      var delta = card.querySelector('[data-placement-price-delta]');
      if (!delta) {
        delta = document.createElement('span');
        delta.setAttribute('data-placement-price-delta', '');
        delta.className = 'diy-placement-price-delta';
        var copy = card.querySelector('.diy-placement-card__copy');
        if (copy) copy.appendChild(delta);
      }
      delta.textContent = priceLabelFor(profile, label);
    });

    var addButton = form.querySelector('.diy-main-product__add');
    var stickyButton = section.querySelector('[data-sticky-submit]');
    var label = current.placements.length ? 'Add custom print to cart' : 'Add blank item to cart';
    if (current.missingPrintSelection) label = 'Choose print area';
    if (current.placements.length && (current.missingUploads.length || current.tooManyUploads)) label = 'Upload artwork to add';

    if (addButton && !addButton.disabled) addButton.textContent = label;
    if (stickyButton) stickyButton.textContent = label;

    section.classList.toggle('diy-configurator-has-print', current.placements.length > 0);
    section.classList.toggle('diy-configurator-missing-upload', current.placements.length > 0 && (current.missingUploads.length > 0 || current.tooManyUploads));
    section.classList.toggle('diy-configurator-missing-print', current.missingPrintSelection);
  }

  function setSubmitting(form, section, isSubmitting, label) {
    var addButton = form.querySelector('.diy-main-product__add');
    var stickyButton = section.querySelector('[data-sticky-submit]');
    if (addButton) {
      addButton.disabled = isSubmitting;
      if (label) addButton.textContent = label;
    }
    if (stickyButton) {
      stickyButton.disabled = isSubmitting;
      if (label) stickyButton.textContent = label;
    }
  }

  function lineKeyFromResponse(response) {
    if (!response) return '';
    if (response.key) return response.key;
    if (Array.isArray(response.items) && response.items[0] && response.items[0].key) return response.items[0].key;
    return '';
  }

  async function postJson(url, payload) {
    var response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    if (!response.ok) throw new Error('Request failed');
    return response.json();
  }

  async function rollbackMainLine(lineKey) {
    if (!lineKey) return;
    await postJson('/cart/change.js', {
      id: lineKey,
      quantity: 0
    });
  }

  async function addConfiguredOrder(form, section, variants, profile) {
    if (form.dataset.diyConfiguratorSubmitting === 'true') return;
    updateConfigurator(section, variants, profile);
    var current = state(section, variants, profile);

    if (current.missingPrintSelection) {
      var placementOptions = section.querySelector('[data-placement-options]');
      if (placementOptions) placementOptions.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (current.placements.length && (current.missingUploads.length || current.tooManyUploads)) {
      var summary = section.querySelector('[data-configurator-summary]');
      if (summary) summary.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    setSubmitting(form, section, true, 'Adding...');
    form.dataset.diyConfiguratorSubmitting = 'true';

    var mainLineKey = '';
    try {
      var linkId = 'diyprint-' + crypto.randomUUID();
      var mainFormData = new FormData(form);
      var mainQuantity = Number(mainFormData.get('quantity') || 1);
      if (!Number.isSafeInteger(mainQuantity) || mainQuantity < 1) throw new Error('Invalid quantity');
      var addonItems = buildAddonItems(profile, current.surcharge, mainQuantity, linkId, current.placementText);
      mainFormData.set('properties[_diyprint_link_id]', linkId);
      var mainResponse = await fetch('/cart/add.js', {
        method: 'POST',
        body: mainFormData,
        headers: {
          Accept: 'application/json'
        }
      });

      if (!mainResponse.ok) throw new Error('Main product add failed');

      var mainJson = await mainResponse.json();
      mainLineKey = lineKeyFromResponse(mainJson);

      if (addonItems.length) {
        await postJson('/cart/add.js', { items: addonItems });
      }

      window.location.href = '/cart';
    } catch (_error) {
      form.dataset.diyConfiguratorSubmitting = 'false';
      try {
        await rollbackMainLine(mainLineKey);
      } catch (_rollbackError) {
        // If rollback fails, avoid silent checkout with a partial cart.
      }

      setSubmitting(form, section, false, 'Could not add - try again');
      window.setTimeout(function () {
        updateConfigurator(section, variants, profile);
      }, 1400);
    }
  }

  function initSection(section) {
    if (section.dataset.diyProductConfiguratorReady === 'true') return;
    section.dataset.diyProductConfiguratorReady = 'true';

    var variants = parseVariants(section);
    var profile = parseProfile(section);
    var update = function (event) {
      if (event && event.target.closest('[data-diy-bulk-builder]')) return;
      window.setTimeout(function () {
        updateConfigurator(section, variants, profile);
      }, 0);
    };

    section.querySelectorAll('input[type="file"].diy-field__file').forEach(ensureUploadControl);
    section.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-upload-trigger]');
      if (trigger && section.contains(trigger)) {
        event.preventDefault();
        var slot = trigger.closest('[data-upload-slot], .diy-print-file-upload, [data-print-file-upload-row]');
        var input = slot ? slot.querySelector('input[type="file"]') : null;
        if (input && !input.disabled) input.click();
        return;
      }

      var remove = event.target.closest('[data-upload-remove]');
      if (remove && section.contains(remove)) {
        event.preventDefault();
        var removeSlot = remove.closest('[data-upload-slot], .diy-print-file-upload, [data-print-file-upload-row]');
        var removeInput = removeSlot ? removeSlot.querySelector('input[type="file"]') : null;
        clearFileInput(removeInput);
        if (removeInput) {
          removeInput.dispatchEvent(new Event('change', { bubbles: true }));
          removeInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
        update();
        return;
      }

      var addUpload = event.target.closest('[data-add-upload-slot]');
      if (addUpload && section.contains(addUpload)) {
        event.preventDefault();
        var area = addUpload.closest('[data-placement-upload-area]');
        if (!area || addUpload.disabled) return;
        var label = area.dataset.placementUploadLabel || area.dataset.placementUploadArea || '';
        var nextIndex = area.querySelectorAll('[data-upload-slot]').length + 1;
        var maxFiles = Number(area.dataset.uploadMaxFiles) || nextIndex;
        if (nextIndex <= maxFiles) createUploadSlot(area, label, nextIndex);
        update();
      }
    });

    section.addEventListener('change', function (event) {
      if (event.target && event.target.matches('input[type="file"].diy-field__file')) {
        ensureUploadControl(event.target);
        syncUploadControl(event.target);
      }
    });

    section.addEventListener('click', update);
    section.addEventListener('change', update);
    section.addEventListener('input', update);

    var stickyButton = section.querySelector('[data-sticky-submit]');
    var form = section.querySelector('form[action*="/cart/add"]') || section.querySelector('form');
    var addButton = form ? form.querySelector('.diy-main-product__add, button[name="add"], button[type="submit"], input[type="submit"]') : null;

    function handleConfiguredSubmit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      addConfiguredOrder(form, section, variants, profile);
    }

    if (addButton && form) {
      addButton.addEventListener('click', handleConfiguredSubmit, true);
    }

    if (stickyButton && form) {
      stickyButton.addEventListener('click', handleConfiguredSubmit, true);
    }

    if (form) {
      form.addEventListener(
        'submit',
        handleConfiguredSubmit,
        true
      );
    }

    updateConfigurator(section, variants, profile);
  }

  window.DIYPrintPricing = { profile: parseProfile, surcharge: calculateSurcharge, addonItems: buildAddonItems };

  function init() {
    document.querySelectorAll('[data-diy-product-configurator]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
